import React, { useState, useRef } from 'react';
import './BrandsPeopleCluster.css';

const brandsList = [
  { id: 3, name: "Guizio", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Guizio.png" },
  { id: 2, name: "Skims", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Skims-2.png" },
  { id: 12, name: "Reformation", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Reformation.png" },
  { id: 5, name: "Alo", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Big-Alo-Male.png" },
  { id: 4, name: "withjean", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-WithJean.png" },
  { id: 13, name: "Vince", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Vince-Female.png" },
  { id: 1, name: "Zara", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Zara.png" },
  { id: 18, name: "Peter Millar", image_url: "https://d1ms1cw6iehark.cloudfront.net/Brand-Card-Peter-Millar-Male.png" },
  { id: 6, name: "Aritzia", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Aritzia-2.png" },
  { id: 17, name: "Lululemon", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Lululemon+(1).png" },
  { id: 11, name: "On", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-On-Male.png" },
  { id: 19, name: "Uniqlo", image_url: "https://d1ms1cw6iehark.cloudfront.net/Brand-Card-Uniqlo.png" },
  { id: 16, name: "Edikted", image_url: "https://d1ms1cw6iehark.cloudfront.net/Brand-Card-Edikted+(1).png" },
  { id: 8, name: "Banana Republic", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Banana-Repablic-Male.png" },
  { id: 15, name: "Asta Resort", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Asta-Resort.png" },
  { id: 14, name: "Theory", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Theory-Female.png" },
  { id: 9, name: "Princess Polly", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-Princess-Polly.png" },
  { id: 10, name: "Victoria's Secret", image_url: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Brand-Card-VS-1.png" }
];

const BrandsPeopleCluster = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const itemWidth = scrollRef.current.offsetWidth * 0.85; 
      const newIndex = Math.round(scrollLeft / itemWidth);
      setActiveIndex(Math.min(newIndex, 3)); 
    }
  };

  return (
    <div className="brands-people-section">
      <h3 className="brands-people-title">BRANDS ACROSS THE WORLD</h3>
      
      <div 
        className="brands-people-carousel" 
        ref={scrollRef}
        onScroll={handleScroll}
      >
        {brandsList.map((brand) => (
          <div key={brand.id} className="brand-person-card">
            <img 
              src={brand.image_url} 
              alt={`${brand.name} collection`} 
              className="brand-person-img" 
            />
          </div>
        ))}
        
        <a href="/brands" className="brand-person-card see-more-card">
          <div className="see-more-icon-wrapper">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
          <span className="see-more-text">See More</span>
        </a>
      </div>

      <div className="mobile-pagination-dots">
        {[0, 1, 2, 3].map((dot) => (
          <span 
            key={dot} 
            className={`dot ${activeIndex === dot ? 'active' : ''}`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default BrandsPeopleCluster;